import { useCallback } from 'react';
import { useIntl } from 'react-intl';

type ArgumentsType = Record<string, string>;

type TranslationArguments = ArgumentsType & {
  defaultValue?: string;
};

type TranslationFunction = (key: string, args?: TranslationArguments) => string;

export const useTranslate = (): TranslationFunction => {
  const { $t } = useIntl();

  return useCallback<TranslationFunction>(
    (key, args) => {
      const { defaultValue, ...rest } = args || {};
      return $t({ id: key, defaultMessage: defaultValue }, rest);
    },
    [$t],
  );
};
